import React from "react";
import { API_URL } from "../../constants/api";
import { SECTIONS } from "../../constants/appConstants";
import { IsSectionVisible } from "../../utils/helper";
import { apiRequest } from "../../utils/api_service";
import "./communication.less";
import AddUpdateCommunication from "./addUpdateCommunication";
import CommunicationTable from "./communicationTable";
import {
  Button,
  FormControlLabel,
  Checkbox,
  Tooltip
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import FilterOff from "../../public/img/common/filterOff.svg";
import RefreshIcon from "@material-ui/icons/Refresh";

/**
 * Base Page for Mass Communication
 */
class massCommunication extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      refreshList: false,
      dataCenterMasterData: [],
      isShowColFilter: true,
      reloadCommTable: false,
      restPage: false,
      content: props?.location?.notificationProps?.content,
      isAddDialogOpen: props?.location?.notificationProps?.isOpenCommunication,
      reply: props?.location?.notificationProps?.isReply,
      mainContent: props?.location?.notificationProps?.content,
    };

  }

 
  /** get Derived State From Props */
  static getDerivedStateFromProps(newProps, state) {
    if (newProps.location?.notificationProps !== (state || {}).notificationProps) {
      // this.LoadData();
      return {
        notificationProps: newProps.location?.notificationProps,
        isAddDialogOpen: state.isAddDialogOpen,
        isOpenCommunication: newProps.location?.notificationProps?.isOpenCommunication,
        content: newProps?.location?.notificationProps?.content,
        reply: newProps?.location?.notificationProps?.isReply,
        mainContent: newProps?.location?.notificationProps?.mainContent,
      };

    }
    else {
      return state;
    }
  }

   /** Component Did mount Call when first time component loads */
   componentDidMount() {
    this.getDataCenterList();
    const props= this.props;
    if (props?.location?.notificationProps?.content !== undefined) {
      this.openViewDialog(props?.location?.notificationProps?.content,
        props?.location?.notificationProps?.reply,
        props?.location?.notificationProps?.mainContent)
    }
  }

  /**
   * Get Datacenter List Based on User Access
   */
  getDataCenterList = () => {
    apiRequest({ url: API_URL.datacenter.getDatacenterList }).then(
      ({ data: dataCenterList }) => {

        const dataCenterMasterData = dataCenterList.map((y) => {
          return {
            DataCenterId: y.propertyID,
            DataCenter: y.name,
            id: y.propertyID,
          };
        });
        this.setState({
          dataCenterMasterData: dataCenterMasterData
        });
      }
    );
  };
  /**
   * Open Add communication PopUP
   * @param {*} isOpen 
   */
  openAddDialog = (isOpen = true) => {
    this.props.location.notificationProps = undefined;
    const{refreshList}=this.state;
    isOpen && localStorage.setItem("IsInEditMode", 0)
    this.setState({ isAddDialogOpen: isOpen, content: undefined, refreshList: !refreshList, mainContent: undefined, reply: false, isCreate: isOpen, isOpenCommunication: isOpen });
  }

  /**
   * Open Add Communication popup in Edit/View Mode
   * @param {*} content 
   * @param {*} reply 
   */
  openViewDialog = (content, reply, mainContent) => {
    this.setState({ isAddDialogOpen: true, content, reply, mainContent: mainContent });
  };

  /**
   * Refresh Communication List
   */
  refreshList = () => {
    const {refreshList} = this.state;

    this.setState({ refreshList: !refreshList });
  }


  render() {

    const { refreshList, isAddDialogOpen, isOpenCommunication, dataCenterMasterData, isShowColFilter, reloadCommTable, restPage } = this.state;


    const canSendCommunication = IsSectionVisible(
      SECTIONS.COMMUNICATION,
      SECTIONS.SEND_COMMUNICATION,
      SECTIONS.ADD_EDIT
    );

    return (

      <div className={"mass-communication-body-wrapper"}>
        {
          (isAddDialogOpen || isOpenCommunication) &&
          <AddUpdateCommunication
            isOpen={(isAddDialogOpen || isOpenCommunication)}
            onClose={this.openAddDialog}
            content={this.state.content}
            mainContent={this.state.mainContent}
            reload={refreshList}
            history={this.props.history}
            refreshList={this.refreshList}
            reply={this.state.reply}
            isCreate={this.state.isCreate}
          />
        }
        <div className={"row"}>
          <div className={"col-xs-12"}>
            <div className={"mass-communication-wrapper"}>
              <div className={"mass-communication-breadcrumb-wrapper"}>
                <span className={"mass-communication-breadcrumb"}>
                  {"HOME | Communication\r"}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className={"row"}>
          {/* action-row */}
          <div className={"col-xs-10"} style={{ display: "flex" }}>
            {
              canSendCommunication && <Button style={{ height: "30px" }} variant={"contained"} size={"small"} onClick={() => { this.openAddDialog(true, true); }}>{"Send New Communication"}</Button>
            }
            <FormControlLabel
              style={{ marginLeft: "5px" }}
              className={"show-filter"}
              control={
                <Checkbox
                  id={"filterCompletedOrCancelled"}
                  color={"primary"}
                  defaultValue={isShowColFilter}
                  checked={isShowColFilter}
                  onChange={(event) =>
                    this.setState({
                      isShowColFilter: event.target.checked,
                    })}
                />
              }
              label={"Show Filters"}
            />
            <Tooltip title={"Clear Filter"} placement={"bottom"}>
              <img
                className={"icons"}
                src={FilterOff}
                alt={"logo"}
                onClick={() => {
                  this.setState({ reloadCommTable: !reloadCommTable });
                }}
              />
            </Tooltip>
          </div>
          <div className={"col-xs-2 end-xs"}>
            <Tooltip title={"Refresh"} placement={"bottom"} >
              <IconButton
                size={"small"}
                onClick={() => { this.setState({ restPage: !restPage }); }}
              >
                <RefreshIcon style={{ fill: "#365E7E", marginTop: "7px", width: "28px", height: "30px" }} />
              </IconButton>
            </Tooltip>
          </div>

        </div>
        <div className={"row communication-table"}>
          {dataCenterMasterData.length > 0 && <CommunicationTable
            openViewDialog={this.openViewDialog}
            isRecordSaved={refreshList}
            sourceData={dataCenterMasterData}
            isShowColFilter={isShowColFilter}
            reloadCommTable={reloadCommTable}
            restPage={restPage}
                                              />}
        </div>
      </div>
    );
  }
}
export default massCommunication;